export default {
  title: 'Test Audience',
  columns: {
    id: 'Id',
    phone_number: 'Phone Number',
  },
  filters: {
    search: {
      placeholder: 'Search',
    },
  },
  buttons: {
    send_test: 'Send Test',
  },
  feedback: {
    success: 'Successfully sent',
    error: 'Failed to send',
  },
};
